<template>
  <div class="sidebar-left sidebar-default sidebar-left-sm" :class="this.theme.sidebarColor">
      <sidebar-item :routers="addRouters" :isCollapse="true"></sidebar-item>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from '@/views/layout/components/Sidebar/SidebarItem'
export default {
  components: { SidebarItem },
  props: {
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'theme',
      'addRouters'
    ])
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue